module.exports = "/images/gb-wls.svg?658f1e67da3afec6b0197fba1d6b3f02";